/* Create by CC 2015-12-09*/
'use strict';
angular.module('iWoSubmitServiceModule', [])
    .factory('iWoSbumitService', function() {
        return {
            initMediaName: function() {
                var mediasArray = [{
                    'mediaName': '纸媒',
                    'mediaType': 3,
                    'type': 'newspaper'
                }, {
                    'mediaName': '网站',
                    'mediaType': 2,
                    'type': 'website'
                }, {
                    'mediaName': '客户端',
                    'mediaType': 1,
                    'type': 'app'
                }, {
                    'mediaName': '微信',
                    'mediaType': 4,
                    'type': 'weixin'
                }, {
                    'mediaName': '微博',
                    'mediaType': 5,
                    'type': 'weibo'
                }, {
                    'mediaName': '数采APP',
                    'mediaType': '',
                    'type': 'scapp'
                }, {
                    'mediaName': '电视',
                    'mediaType': 15,
                    'type': 'television'
                }, {
                    'mediaName': '广播',
                    'mediaType': 16,
                    'type': 'broadcast'
                }, {
                    'mediaName': '抖音',
                    'mediaType': 17,
                    'type': 'tiktok'
                }, {
                    'mediaName': '百家号',
                    'mediaType': 18,
                    'type': 'baijiahao'
                }, {
                    'mediaName': '企鹅号',
                    'mediaType': 19,
                    'type': 'qiehao'
                }, {
                    'mediaName': '头条号',
                    'mediaType': 20,
                    'type': 'toutiao'
                }, {
                    'mediaName': '快手',
                    'mediaType': 25,
                    'type': 'kuaishou'
                }];
                return mediasArray;
            },
            initTreeOpition: function() {
                var treeOptions = {
                    nodeChildren: 'CHILDREN',
                    dirSelectable: true,
                    allowDeselect: false,
                    injectClasses: {
                        ul: 'a1',
                        li: 'a2',
                        liSelected: 'a7',
                        iExpanded: 'a3',
                        iCollapsed: 'a4',
                        iLeaf: 'a5',
                        label: 'a6',
                        labelSelected: 'a8'
                    },
                    isLeaf: function(node) {
                        return node.HASCHILDREN == 'false';
                    }
                };
                return treeOptions;
            },
            initAppTreeOption: function() {
                var appTreeOptions = {
                    nodeChildren: 'ZONE_COLUMNS',
                    dirSelectable: true,
                    allowDeselect: false,
                    injectClasses: {
                        ul: 'a1',
                        li: 'a2',
                        liSelected: 'a7',
                        iExpanded: 'a3',
                        iCollapsed: 'a4',
                        iLeaf: 'a5',
                        label: 'a6',
                        labelSelected: 'take-draft-tree-label-sel',
                    },
                    isLeaf: function(node) {
                        return node.ZONE_COLUMNS == undefined;
                    }
                };
                return appTreeOptions;
            }
        };
    });
